import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';

class View extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.NUCLEOS)
            return null;

        const cities = this.props.nucleo.cities;

        if (!cities)
            return;

        const token = this.props.token;

        const editorFields = [
            { "label": "Nome", "name": "name" },
            {
                "label": "Cidade",
                "name": "city.id",
                "type": "select",
                "options": cities,
                "optionsPair": {
                    label: 'name',
                    value: 'id'
                }
            }
        ];

        const datatablesColumns = [
            {
                data: "serial",
                title: "Serial",
                width: 45,
                render: function (data, type) {
                    if (type === "display") {
                        let ret = data.toString();
                        if (ret.length === 1) return "00" + ret;
                        if (ret.length === 2) return "0" + ret;
                        return ret;
                    }

                    return data;
                }
            },
            { data: "name", title: "Nome", render: $.datatable.renders.text() },
            { data: "city.name", title: "Cidade", render: $.datatable.renders.text() },
            { data: "dateCreated", title: "Criação", render: $.datatable.renders.datetime(), width: 160 },
            { data: "dateUpdated", title: "Edição", render: $.datatable.renders.datetime(), width: 160 },
        ];

        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: '/api/centers/select',
            createUrl: '/api/centers/insert',
            editUrl: '/api/centers/update/_id_',
            removeUrl: '/api/centers/delete/_id_',
        });

        const editorCreateTitle = 'Inserir núcleo';
        const editorEditTitle = 'Editar núcleo';
        const editorRemoveTitle = 'Remover núcleo';
        const editorRemoveMessage = 'Deseja remover este núcleo?';

        const domClassName = 'centers-datatables';
        const title = 'Núcleos';
        const subTitle = 'Gerenciamento';

        return (
            <Datatable DomClassName={domClassName}
                       title={title}
                       subTitle={subTitle}
                       responsive={true}
                       pageLength={30}
                       editorCreateVisible={true}
                       editorCreate={callbacks.create.bind(callbacks)}
                       editorCreateTitle={editorCreateTitle}
                       editorEditVisible={true}
                       editorEdit={callbacks.edit.bind(callbacks)}
                       editorEditTitle={editorEditTitle}
                       editorRemoveVisible={true}
                       editorRemove={callbacks.remove.bind(callbacks)}
                       editorRemoveTitle={editorRemoveTitle}
                       editorRemoveMessage={editorRemoveMessage}
                       editorFields={editorFields}
                       datatablesSelect={callbacks.select.bind(callbacks)}
                       datatablesColumns={datatablesColumns}
            />
        );
    }
}

export default View;


// WEBPACK FOOTER //
// src/views/pages/Nucleos.jsx